import React, { useEffect, useRef, useState } from 'react';

import { connect, shallowEqual, useDispatch, useSelector } from 'react-redux';

import { LayoutSplashScreen } from '../../../_metronic/layout';

import { authSlice } from './redux';

function Authenticator(props) {
  const { requestCognito, requestUser, signOut } = props;

  const auth = useSelector(({ auth }) => auth, shallowEqual);
  const dispatch = useDispatch();
  const requestingCognito = useRef(false);
  const requestingUser = useRef(false);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    try {
      if (!auth.cognito) {
        if (requestingCognito.current || auth.cognitoFulfilled) {
          setLoading(false);
        } else {
          dispatch(requestCognito());
          requestingCognito.current = true;
        }
        return;
      }

      if (!auth.user) {
        if (requestingUser.current || auth.userFulfilled) {
          setLoading(false);
        } else {
          dispatch(requestUser());
          requestingUser.current = true;
        }
        return;
      }

      setLoading(false);
    } catch (error) {
      console.error(error);
      dispatch(signOut());
      setLoading(false);
    }

  }, [
    auth,
    dispatch,
    requestCognito,
    requestUser,
    requestingCognito,
    requestingUser,
    signOut,
  ]);

  return loading
    ? <LayoutSplashScreen />
    : <>{props.children}</>;
}

export default connect(null, authSlice.actions)(Authenticator);
